const helpVersion = '020300';
/**
 * version history:
 *
 * version 2.3.0 => 020300 - map as sphere with navigator and help.js
 * Increase version Number and add a new item to helpMenu with the new version number.
 *
 * */

/**
 * helpMenu
 *
 * id: unique identifier
 * title_de, content_de -> german content
 * title_en, content_en -> english content todo
 * position -> tailwind classes to position the modal
 * version -> corresponding number to global helpVersion. version 2.3.0 => 020300
 * backdrop -> what happens if you click on backdrop
 * arrow -> shows arrow left or right side of modal
 * highlight -> node selector: this node will be forced to be visible and the highlight-canvas is placed around it
 * needs -> node selector: helpItem is only active if this node is visible
 *
 */
const helpMenu = {
        "/": [
            {
                id: "welcome",
                title_de: "Willkommen in der map, einer Methodischen Anwendung zum Planungs- und Bauprozess.",
                content_de: "Unser open source Atlas bezweckt, die eigene Neugierde zu befeuern und animiert, durch Zufall Neues zu erfahren.<br><br>" +
                    "Sieh dir nun einige Tipps zum Gebrauch der map an.",
                position: 'left-1/2 top-1/4',
                version: 20300,
                backdrop: 'commit'
            },
            {
                id: "navigation",
                title_de: "Navigator",
                content_de: "Hier kannst du zwischen map, Vorlesung und Denkfabrik navigieren sowie eine Suche starten.<br>" +
                    "Vorlesungen sind nur für ETH Angehörige zugänglich<br><br>" +
                    "Öffne und Schliesse den Navigator über das Menu- & Schliessen-Icon rechts oben im Header.",
                position: 'left-1/2 top-20',
                highlight: '#navigator .navigator-inner-box',
                arrow: 'right',
                backdrop: 'commit',
                version: 20300
            },
            {
                id: "mode",
                title_de: "Ansichtsmodus",
                content_de: "Hier kannst du die Ansicht des Bauprozesses zwischen Tabelle, Sphäre, Leseliste und Target Modus wechseln.<br>" +
                    "Auf dem Smartphone steht nur die Leseliste zur Verfügung.",
                position: 'left-1/2 top-44',
                highlight: '#navigator #tool-box-view',
                arrow: 'right',
                backdrop: 'commit',
                version: 20300
            },
            {
                id: "phase",
                needs: "#map-sphere",
                title_de: "Prozessphase",
                content_de: "Hier kannst du die Phase des Bauprozesses auf der Sphäre steuern. Das funktioniert auch mit dem Touchpad, der Maus oder den Pfeil-Tasten.",
                position: 'left-1/2 top-24',
                highlight: '#navigator .navigator-inner-box .map-phase',
                arrow: 'right',
                backdrop: 'commit',
                version: 20300
            },
            {
                id: "target",
                needs: "#map-list.target-mode",
                title_de: "Verknüpfungsmodus",
                content_de: "Klicke auf einen bestimmten Artikel, um zum Verknüpfungsmodus zu gelangen. Dort findest du inhaltlich verlinkte Artikel.",
                position: 'left-1/2 top-48',
                highlight: '.map-overview-grid',
                arrow: 'left',
                backdrop: 'commit',
                version: 20300
            },

        ],
        "/vorlesungen": [
            {
                id: "lecture",
                title_de: "Vorlesungen",
                content_de: "Wähle den Kurs und das Semester im Navigator um zu einer bestimmten Vorlesung zu gelangen.<br><br>" +
                    "Diese Einstellungen werden für dich gespeichert.",
                position: 'left-1/2 top-44',
                highlight: '#navigator .navigator-inner-box',
                arrow: 'right',
                backdrop: 'commit',
                version: 20300
            },
        ],
        "/denkfabrik" : [
            {
                id: "tag",
                title_de: "Denkfabrik nach Schlagwort filtern",
                content_de: "Wähle ein Schlagwort um die Artikel zu filtern. Oder blättere im Navigator durch die Seiten.",
                position: 'left-2/3 top-20',
                highlight: '.tag-cloud',
                arrow: 'left',
                backdrop: 'commit',
                version: 20300
            },
        ],
        "/denkfabrik/filter/*" : [
            {
                id: "remove_tag",
                title_de: "Schlagwort zurücksetzen",
                content_de: "Lösche das Schlagwort hier. Oder klicke erneut auf das aktive Schlagwort um es zurückzusetzen.",
                position: 'left-1/2 top-48',
                highlight: '#navigator #tool-box-researchTag',
                arrow: 'right',
                backdrop: 'commit',
                version: 20300
            },
        ],
    };

let mapModal;

(function($){
    $(function($) {
        initHelp();
    })
})(jQuery);

initHelp = function() {
    const userVersion = localStorage.getItem('map.help.version') || 0;
    // todo const locale = document.getElementsByTagName("html")[0].getAttribute("lang");
    const locale = 'de'; // we show de in all cases - we do not have translations yet.
    if (userVersion < parseInt(helpVersion, 10)) {
        let largeDetector = $('.media-detector .large');
        if (largeDetector.is(':visible')) {
            mapModal = new MapHelpModal(userVersion, locale);
            mapModal.initHelpMenu(0);
        }
    }
}
revokeHelp = function() {
    if (mapModal && !mapModal.activeModal) {
        mapModal.initHelpMenu(0);
    }
}

MapHelpModal = function(userVersion, locale) {
    this.page = null;
    this.modal = $('#mapHelpModal');
    this.activeModal = null;

    this.page = window.location.href.replace(
        window.location.protocol + '//' +
        window.location.href.split("/")[2], '');

    Object.keys(helpMenu).map(key => {// finding /denkfabrik/filter/* with all parameters
        if (key.endsWith('*') &&
            this.page.startsWith(key.replace('*', ''))) {
            this.page = key;
        }
    })
    this.userVersion = userVersion;
    this.lang = locale;
};
MapHelpModal.prototype = {
    initHelpMenu: function(index) {
        const helpItem = helpMenu[this.page] ? helpMenu[this.page][index] : null;
        if (helpItem) {
            if (
                this.isValid(helpItem) && (
                !localStorage.getItem('map.help.' + helpItem.id) ||
                helpItem.version > localStorage.getItem('map.help.' + helpItem.id))
            ) {
                this.activeModal = {helpItem, index};
                this.showModal()
            } else {
                this.activeModal = null;
                this.initHelpMenu(index + 1);
            }
        }
    },
    showModal: function() {
        $('body').addClass('no-scroll');
        $('body.no-scroll')[0].addEventListener('scroll', preventScroll, {passive: false})
        $('body.no-scroll')[0].addEventListener('touchmove', preventScroll, {passive: false})
        $('body.no-scroll')[0].addEventListener('mousewheel', preventScroll, {passive: false})
        $('body.no-scroll')[0].addEventListener('wheel', preventScroll, {passive: false})


        const item = this.activeModal.helpItem;

        const popUp = this.modal.find('.map-popUp');
        popUp.addClass(item.position);
        if (item.arrow) {
            popUp.addClass(item.arrow);
        }
        this.modal.find('.map-popUp-title').html(item['title_' +this.lang]);
        this.modal.find('.map-popUp-content').html(item['content_' +this.lang]);

        this.modal.removeClass('hidden');

        setTimeout( () => {
            $(window).scrollTop(0);
            if (item.highlight) {
                this.modal.addClass('highlight');
                this.showWindow(item.highlight);
            }
        }, 10); // wait for dimensions

        if (item.highlight && item.highlight.startsWith('#navigator')) {// force menu to open
            $('#menu-trigger').removeClass('closed')
            $('#navigator').show();
        }
    },
    showWindow: function(id) {

        const element = $(id);
        const domRect = element[0].getBoundingClientRect();

        $('<canvas>', {
            id: 'highlight-window',
        }).prependTo(this.modal);

        const canvas = $("#highlight-window")[0];

        const ctx = canvas.getContext("2d");
        const width = canvas.width = this.modal.width();
        const height = canvas.height = this.modal.height();

        ctx.fillStyle = "rgba(0,0,0,0.5)";
        ctx.fillRect(0, 0, width, height);
        ctx.clearRect(domRect.x, domRect.y, element[0].offsetWidth, element[0].offsetHeight);
    },
    isValid: function(helpItem) {
        // valid detects if targeted element is visible on current page. (map->ansichtsmodus)
        return !helpItem.needs || ($(helpItem.needs) && $(helpItem.needs).is(':visible'));
    },
    commit: function() {
        localStorage.setItem('map.help.' + this.activeModal?.helpItem?.id, this.activeModal?.helpItem?.version);
        this.resteModal();
        this.initHelpMenu(this.activeModal?.index + 1);
    },
    resteModal: function() {

        $('body.no-scroll')[0].removeEventListener('scroll', preventScroll, {passive: false})
        $('body.no-scroll')[0].removeEventListener('touchmove', preventScroll, {passive: false})
        $('body.no-scroll')[0].removeEventListener('mousewheel', preventScroll, {passive: false})
        $('body.no-scroll')[0].removeEventListener('wheel', preventScroll, {passive: false});

        this.modal[0].classList = 'map-modal hidden';
        $('body').removeClass('no-scroll');

        $('#highlight-window').remove();
        this.modal.find('.map-popUp')[0].classList = 'map-popUp';
        this.modal.find('.map-popUp-title').html('');
        this.modal.find('.map-popUp-content').html('');

    },
    cancel: function() {
        this.resteModal();
        localStorage.setItem('map.help.version', helpVersion);
    },
    backdrop: function() {
        if (this.activeModal?.helpItem?.backdrop === 'commit') {
            this.commit();
        } else {
            this.cancel();
        }
    }
}

cancelModal = function(e) {
    e.stopPropagation();
    mapModal.cancel(e);
};
confirmModal = function(e) {
    e.stopPropagation();
    mapModal.commit();
}
backdropClick = function() {
    mapModal.backdrop();
}

preventScroll = function(e) {
    $(window).scrollTop(0);
    e.preventDefault();
    e.stopPropagation();
    return false;
}
